import moment from "moment-timezone";

import {
    filterWithoutClosedAccountingPeriods,
    filterWithSelectedAccountingPeriod,
} from "@/services/accountingPeriods";
import { Component, Vue, Model, Watch } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Emit } from "vue-facing-decorator";

@Component
export class ossDatePickerBase extends Vue {
    @Prop({ default: undefined }) object;
    @Prop({ default: "" }) label: string;
    @Prop({ default: "" }) placeholder: string;
    @Prop({ default: undefined }) minDate: string;
    @Prop({ default: undefined }) maxDate: string;
    // @Prop({ default: undefined }) pickerDate: string;
    @Prop({ default: "" }) date: string;
    @Prop({ default: false }) required: boolean;
    @Prop({ default: false }) hideDetails: boolean;
    @Prop({ default: "date" }) type: string;
    @Prop({ default: "DD/MM/YYYY" }) format: string;
    @Prop({ default: true }) outlined: boolean;
    @Prop({ default: true }) dense: boolean;
    @Prop({ default: true }) textFieldReadOnly: boolean;
    @Prop({ default: "" }) textFieldClass: string;
    @Prop({ default: false }) filterWithoutClosedAccountingPeriods: boolean;
    @Prop({ default: false }) filterWithSelectedAccountingPeriod: boolean;
    @Prop({ default: false }) hideActivator: boolean;
    @Prop({ default: false }) activate: boolean;
    @Prop({ default: true }) mandatory: boolean;
    @Prop({ default: false }) readonly: boolean;
    @Prop({ default: false }) error: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) notRequired: boolean;
    @Prop({ default: false }) noMenu: boolean;
    @Prop({ default: false }) autofocus: boolean;
    @Prop({ default: "" }) prefixDataCy: string;
    @Prop() tabindex: number;
    @Prop() hint: string;
    @Prop() persistentHint: boolean;
    @Prop({ default: undefined }) showCurrent: string; // ** to open the calendar focused on the given date, format "YYYY-MM-DD"
    @Prop({ default: () => ({}), required: false }) basePickerProps: { [key: string]: unknown }; // Props passed to the base date picker component
    @Prop({ required: false }) returnDateStringFormat: string;

    internalValue = null; // Base date picker value
    textFieldValue: string = ""; // Base text field value

    @Model() value: string;

    @Watch("internalValue", { deep: true, immediate: false })
    onInternalValueChanged(value: unknown) {
        // debugger;
        if (this.returnDateStringFormat) {
            let formattedValue: string | string[];
            if (Array.isArray(value)) {
                formattedValue = value.map((val) =>
                    moment(val).format(this.returnDateStringFormat),
                );
            } else {
                formattedValue = moment(value).format(this.returnDateStringFormat);
            }
            this.$emit("update:modelValue", formattedValue);
        } else {
            this.$emit("update:modelValue", value);
        }
    }

    @Watch("value", { deep: true, immediate: false })
    @Watch("date", { deep: true, immediate: false })
    onValueChanged(value: unknown) {
        // debugger;
        if (
            this.value &&
            this.internalValue &&
            moment(this.value).format() === moment(this.internalValue).format()
        ) {
            // Skip if the dates are equivalent
            return;
        }
        this.internalValue = value;
        if (this.internalValue) {
            // If the new date is different from the displayed date in textfield, update the textfield
            if (
                moment(this.textFieldValue, this.expectedDateEntryFormats, true).format() !==
                moment(this.internalValue).format()
            ) {
                this.textFieldValue = this.formatDateFunction(this.internalValue);
            }
        }
    }

    beforeMount() {
        // Initial internal date value. Note that modeValue (this.value) takes precedence over this.date and should be preferred to date prop (May be removed in the future)
        this.internalValue = this.value ?? this.date;
        if (this.internalValue) {
            this.textFieldValue = this.formatDateFunction(this.internalValue);
        }
    }

    dateDialog_: boolean = false;

    openDialogFromTextField() {
        if (!this.hideActivator && this.textFieldReadOnly && !this.readonly && !this.disabled) {
            this.dateDialog = true;
        }
    }

    /**
     * Props passed to the base date picker component
     */
    get pickerProps() {
        return this.basePickerProps ?? {};
    }

    get fullTextFieldClass() {
        let tfClass = "small-prepend-icon w-full";
        if (this.textFieldClass) {
            tfClass += " " + this.textFieldClass;
        }
        return tfClass;
    }

    get dateDialog() {
        return this.activate || this.dateDialog_;
    }

    set dateDialog(value) {
        this.dateDialog_ = value;
    }

    get localDate() {
        if (Array.isArray(this.internalValue)) {
            return this.internalValue;
        }
        if (this.savedDate) {
            if (
                typeof this.savedDate === "string" &&
                moment(this.savedDate, this.format, true).isValid()
            ) {
                return moment(this.savedDate, this.format).toDate();
            }
            return moment(this.savedDate).toDate();
        } else if (this.date) {
            if (typeof this.date === "string" && moment(this.date, this.format, true).isValid()) {
                return moment(this.date, this.format).toDate();
            }
            return moment(this.date).toDate();
        } else if (this.internalValue) {
            if (
                typeof this.internalValue === "string" &&
                moment(this.internalValue, this.format, true).isValid()
            ) {
                return moment(this.internalValue, this.format).toDate();
            }
            return moment(this.internalValue).toDate();
        }
        return null;
        // return new Date();
    }

    savedDate = null;

    set localDate(date) {
        if (Array.isArray(this.internalValue)) {
            this.internalValue = date;
        } else if (!this.object) {
            this.emitChangeDate(date);
            this.internalValue = date;
            this.savedDate = date;
        } else {
            this.internalValue = date;
            this.emitChangeDate({
                object: this.object,
                date,
            });
            this.savedDate = {
                object: this.object,
                date,
            };
        }
    }

    @Emit("change-date")
    emitChangeDate(date) {
        return date;
    }

    formatDateFunction(date) {
        // debugger;
        const mDate = moment(date);
        if (!mDate.isValid() || (typeof date === "string" && date.length < this.format.length)) {
            return this.appendSlashToDateEntry(date);
        }
        return mDate.format(this.format);
    }

    /**
     * Append slash to date entry with respect to the type of date picker
     * @param dateStr
     * @returns formatted date string
     */
    appendSlashToDateEntry(dateStr: string): string {
        let temp = dateStr;
        if (temp && this.type !== "year") {
            if (temp.length === 2) {
                temp = temp + "/";
            } else if (temp.length === 5 && this.type === "date") {
                temp = temp + "/";
            }
        }
        return temp;
    }

    /**
     * Update date values when the input changes. Called with textfield update:model-value
     * @param value
     * @returns
     */
    onTextFieldValueChanged(value: string) {
        // debugger;
        if (!moment(value, this.expectedDateEntryFormats, true).isValid()) {
            // Strict format check
            // debugger;
            if (this.mandatory) {
                // TODO: do we need to keep the mandatory ? In practice, it may lead to inconsistant dates between what the user sees and what the value behind
                this.internalValue = this.savedDate;
            } else if (value === "" || value == null) {
                // Reset dates to empty state
                // debugger;
                this.internalValue = "";
                this.savedDate = null;
                this.localDate = null;
            } else {
                this.internalValue = null;
                this.localDate = null;
            }
            value = this.appendSlashToDateEntry(value);
            this.textFieldValue = value;
            return;
        }
        this.textFieldValue = value;
        const date = moment(value, this.expectedDateEntryFormats).format("YYYY-MM-DD") || "";
        this.localDate = moment(date, "YYYY-MM-DD").toDate();
        this.internalValue = this.savedDate;
    }

    /**
     * Update text field value when a date is picked from date picker. Called with datepicker update:model-value
     * @param value
     * @returns
     */
    onDatePickerValueChanged(value) {
        // debugger;
        if (value) {
            const date = moment(value).format("YYYY-MM-DD");
            // this.internalValue = date;
            this.textFieldValue = moment(date).format(this.format);
            // this.savedDate = date;
        }
    }

    /**
     * Allow YY year format when YYYY is selected
     */
    get expectedDateEntryFormats(): string | string[] {
        // debugger;
        if (this.format) {
            const formats = [this.format];
            if (this.format.includes("YYYY")) {
                formats.push(this.format.replace("YYYY", "YY"));
            }
            // console.log("formats", formats);
            return formats;
        }
        return this.format;
    }

    /**
     * Format date to display in text field
     */
    get formatDate() {
        // debugger;
        const date = this.internalValue; //this.date ?? this.internalValue;
        if (Array.isArray(date)) {
            return `${this.formatDateFunction(date[0])} au ${this.formatDateFunction(date[1])}`;
        }
        if (!date && !this.textFieldValue) {
            if (this.textFieldReadOnly) {
                return "Choisir une date";
            } else {
                return "";
            }
        }
        return this.textFieldValue;
    }

    /**
     * Append the / on keypress, except for deletion
     * @param keycode
     */
    onKeyPress(keycode) {
        // debugger
        if (keycode !== 46) {
            this.textFieldValue = this.appendSlashToDateEntry(this.textFieldValue);
        }
    }

    _isValid(_date: Date) {
        if (!_date) {
            return "Date requise";
        }
        const date = moment(_date).format("YYYY-MM-DD");
        if (date.match(/[0-9]{4}-[0-1][0-9]-[0-3][0-9]/)) {
            const mDate = moment(date);
            if (mDate.isValid()) {
                if (this.minDate) {
                    if (mDate.isBefore(moment(this.minDate).startOf("day"))) {
                        return "Date impossible";
                    }
                }
                if (this.maxDate) {
                    if (mDate.isAfter(moment(this.maxDate).startOf("day"))) {
                        return "Date impossible";
                    }
                }
                return this.allowedDates(date);
            } else {
                return "Date non valide";
            }
        }
        return "Date non valide";
    }

    isValid() {
        if (this.notRequired) {
            if (!this.localDate) return true;
        }
        if (!this.localDate) {
            return !this.mandatory;
        }
        if (!Array.isArray(this.localDate)) {
            return this._isValid(this.localDate);
        }
        for (const date of this.localDate) {
            const result = this._isValid(date);
            if (result != true) {
                return result;
            }
        }
        return true;
    }

    emitDate() {
        this.internalValue = this.savedDate;
        this.close();
    }

    @Emit("close")
    close() {
        // this.savedDate = null;
        this.dateDialog = false;
        return;
    }

    allowedDates(date) {
        if (this.filterWithoutClosedAccountingPeriods) {
            return filterWithoutClosedAccountingPeriods(
                this.$store.state.accountingPeriod.accountingPeriods,
                date,
            );
        }
        if (this.filterWithSelectedAccountingPeriod) {
            return filterWithSelectedAccountingPeriod(
                this.$store.state.accountingPeriod.selectedAccountingPeriod,
                date,
            );
        }
        return true;
    }

    @Emit("tab")
    handleKeydown(event) {
        if (event.key === "Tab") {
            return event;
        }
    }

    @Emit("mouseout")
    onMouseOut() {
        return;
    }

    @Emit("mouseover")
    onMouseOver() {
        return;
    }
}
